import React from 'react';

import { Link } from '@reach/router';
import { useSelector } from 'react-redux';

import { socialProofAmount } from '../../../provider/models/franchisesModel';
import BackButton from '../../BackButton/BackButton';
import Button from '../../Button/Button';
import CompactContactForm from '../../CompactContactForm';
import GeneralTile from '../../GeneralTile/GeneralTile';
import LinearLoading from '../../LinearLoading';
import MainTitleDescription from '../../MainTitleDescription/MainTitleDescription';
import ProgressBar from '../../ProgressBar/ProgressBar';
import styles from './SingleInputPage.module.scss';

export default function SingleInputPage({
  setLoading,
  backButton,
  backButtonLink,
  nextButton,
  nextButtonLink,
  errorMessage,
  loading,
  noProgressBar,
  noTiles,
  currentStep,
  content,
  page,
  genericMessageType,
}) {
  const steps = useSelector((store) => store.data.steps);
  const logoSrc = useSelector((store) => store.data.logoSrc);
  const mainTitle = useSelector((store) => store.data.mainTitleDescription);
  const chooseText = useSelector((store) => store.data.mainTitleDescriptionAlt);
  const generalTiles = useSelector((store) => store.data.generalTiles);

  const currentAge = useSelector((store) => store.state.age);
  const currentService = useSelector((store) => store.state.service);
  const currentCity = useSelector((store) => store.state.city);

  const singleInputPageTexts = useSelector(
    (store) => store.data.singleInputPage,
  );
  const nextText = useSelector((store) => store.data.nextText);

  const tileComponents = (
    <>
      <GeneralTile
        key={0}
        width={'25%'}
        data={
          currentCity
            ? {
                ...generalTiles[0],
                type: 3,
                title: currentCity.text,
                description: singleInputPageTexts.descriptions[1],
              }
            : generalTiles[0]
        }
      />
      <GeneralTile
        key={1}
        width={'25%'}
        data={
          currentService
            ? {
                ...generalTiles[1],
                type: 3,
                title: currentService.title,
                description: singleInputPageTexts.descriptions[0],
              }
            : generalTiles[1]
        }
      />
      <GeneralTile
        key={2}
        width={'25%'}
        data={
          currentAge
            ? {
                ...generalTiles[2],
                type: 3,
                title: currentAge.text,
                description: singleInputPageTexts.descriptions[2],
              }
            : {
                ...generalTiles[2],
                title:
                  socialProofAmount > generalTiles[2].title
                    ? socialProofAmount
                    : generalTiles[2].title,
              }
        }
      />
    </>
  );

  const backButtonComp = backButton ? (
    <Link to={backButtonLink || `../`}>
      <BackButton />
    </Link>
  ) : (
    <div></div>
  );

  const nextButtonComp = nextButton ? (
    <Link to={nextButtonLink}>
      <Button type={'primary'} text={nextText} />
    </Link>
  ) : (
    <div></div>
  );

  const errorMessageComp = (
    <div className={styles.errorMessage}>{errorMessage}</div>
  );

  const navButtons = (
    <div className={styles.navWrapper}>
      {backButtonComp}
      {nextButtonComp}
    </div>
  );

  return (
    <>
      {loading ? <LinearLoading /> : <div style={{ height: '4px' }}></div>}
      <div style={{ position: 'relative' }}>
        <div className={styles.container} style={{ position: 'relative' }}>
          <div
            className={styles.logo}
            style={{ backgroundImage: `url('${logoSrc}')` }}
          ></div>
          {!noProgressBar ? (
            <ProgressBar currentStep={currentStep} steps={steps} />
          ) : null}
          <div className={styles.formContainer}>
            {!noTiles
              ? [
                  <MainTitleDescription
                    key={0}
                    title={
                      currentService || currentCity || currentAge
                        ? chooseText
                        : mainTitle.title
                    }
                    description={
                      currentService || currentCity || currentAge
                        ? ''
                        : mainTitle.description
                    }
                  />,
                  <div key={1} className={styles.tileContainer}>
                    {tileComponents}
                  </div>,
                ]
              : null}
            {content}
            {errorMessage ? (
              <>
                {errorMessageComp}
                <CompactContactForm
                  setLoading={setLoading}
                  backButtonLink={backButtonLink}
                  genericType={genericMessageType}
                  page={page}
                />
              </>
            ) : (
              navButtons
            )}
          </div>
        </div>
        {loading && <div className={styles.loadingContainer}></div>}
      </div>
    </>
  );
}
